export default {
  namespaced: true,
  traffic: {
    title: "traffic",
    counter: "counter",
    reset: "reset counter",
    request: "request",
    created: "first connection",
    imei: "imei",
    ip: "ip",
    alarm: "alarm",
    counter: "counter",
    with_counter: "traffic with counters",
    without_counter: "traffic without counters",
    updatedAt: "last update"
  },
};
